/** For `AutocompleteArrayInput` list filters: match the 36px search / select controls (selected chips still wrap) */
export const filterAutocompleteClassName =
  'min-w-0 max-w-full [&_[cmdk-root]]:min-w-0 [&_[cmdk-root]]:p-0 [&_input]:min-w-0 [&_input]:leading-5';
